import bodyHeader from "../../../images/bodyHeader.jpg";
import './BodyHeader.css'
export default function BodyHeader({ pageHeader, ...props }) {
  return (
    <div
      className="header-image"
      style={{
        backgroundImage: `url(${bodyHeader})`,
      }}
    >
      <div className="page-header"{...props}>{pageHeader}</div>{" "}
    </div>
  )
}